module.exports = __webpack_public_path__ + "static/media/report-icon.ca690de9.svg";